<template>
  <section>
    <div class="col-sm-12 table-responsive tbl-display-fixture" v-if="fixture.id">
      <table class="table table-bordered">
        <thead>
        <tr>
          <td class="text-center" width="15%"><strong>Time</strong></td>
          <td class="text-center">Match Status</td>
          <td class="text-center" width="15%"><strong>Home</strong></td>
          <td class="text-center" width="5%"><strong>Score</strong></td>
          <td class="text-center" width="15%"><strong>Away</strong></td>
          <td class="text-center" width="5%"><strong>FT</strong></td>
          <td class="text-center" width="5%"><strong>HT</strong></td>
          <td class="text-center">Status</td>
          <td class="text-center" width="15%"><span class=" btn  btn-xs text-white" :class="timeSync<4?'btn-warning':'btn-info'" @click="reload()"> ( {{ timeSync}} ) Reload</span>
          </td>
          <td class="text-center"><a :href="switchUrl" class="text-info">Go to In Play</a></td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-center" width="15%">
            <small>
              {{ getMoment(fixture.local_starting_at, 'MMM') }} {{ getMoment(fixture.local_starting_at, 'YYYY') }}<br/>
              {{ getMoment(fixture.local_starting_at, 'DD') }} {{ getMoment(fixture.local_starting_at, 'dddd HH:mm') }}
            </small>
          </td>
          <td class="text-center">
            <span class="text-info" v-html="getMatchStatus(fixture)"></span>
          </td>
          <td class="text-center" width="15%">
            <span class="pull-left" v-html="getTeamIcon(getProperty(fixture,'meta.localteam.logo_path'))"></span>{{ fixture.meta.localteam.name }}
          </td>
          <td class="text-center" width="5%">{{ scoreDisplayScore(fixture) }}</td>
          <td class="text-center" width="15%">{{ fixture.meta.visitorteam.name }}<span class="pull-right" v-html="getTeamIcon(getProperty(fixture,'meta.visitorteam.logo_path'))"></span>
          </td>
          <td class="text-center" width="5%">{{ scoreDisplay(fixture) ? fixture.ft_score : '?-?' }}</td>
          <td class="text-center" width="5%">{{ scoreDisplay(fixture) ? fixture.ht_score : '?-?' }}</td>
          <td class="text-center">{{ fixture.status }}</td>
          <td class="text-center" width="15%">{{ fixture.updated_at }}</td>
          <td class="text-center">
            <span class="btn-sync-fixture btn btn-sm btn-info" @click="syncFixtureById(fixture.id)"><i class="fa fa-refresh"></i> อัพเดตข้อมูล</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-12" v-if="fixture.id">
      <a href="javascript:void(0)" v-on:click='showStats = !showStats'><i class="fa fa-signal"></i> {{ showStats?'Hide':'Show Stats' }}</a>

      <table class="table " v-show="showStats">
        <thead>
        <tr>
          <td width="45%"></td>
          <td></td>
          <td width="45%"></td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-right">
            <span v-html="getTeamIcon(getProperty(fixture,'meta.localteam.logo_path'))"></span>{{ fixture.meta.localteam.name }}
          </td>
          <td></td>
          <td class="text-left">{{ fixture.meta.visitorteam.name }}<span v-html="getTeamIcon(getProperty(fixture,'meta.visitorteam.logo_path'))"></span>
          </td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'attacks[0]', '-') }}</td>
          <td class="text-center" width="150px">Attacks</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'attacks[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corners[0]', '-') }}</td>
          <td class="text-center" width="150px">Corners</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corners[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corner_ft[0]', '-') }}</td>
          <td class="text-center" width="150px">Corner FT</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corner_ft[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'corner_ht[0]', '-') }}</td>
          <td class="text-center" width="150px">Corner HT</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'corner_ht[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'dangerous_attacks[0]', '-') }}</td>
          <td class="text-center" width="150px">Dangerous Attacks</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'dangerous_attacks[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'goals[0]', '-') }}</td>
          <td class="text-center" width="150px"><i class="fa fa-soccer-ball-o"></i> Goals</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'goals[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'off_target[0]', '-') }}</td>
          <td class="text-center" width="150px">Off Target</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'off_target[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'on_target[0]', '-') }}</td>
          <td class="text-center" width="150px">On Target</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'on_target[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'penalties[0]', '-') }}</td>
          <td class="text-center" width="150px">Penalties</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'penalties[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'possession_percent[0]', '-') }}</td>
          <td class="text-center" width="150px">Possession Percent</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'possession_percent[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'redcards[0]', '-') }}</td>
          <td class="text-center" width="150px"><i class="football-card red-card"></i> Red cards</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'redcards[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'yellowcards[0]', '-') }}</td>
          <td class="text-center" width="150px"><i class="football-card yellow-card"></i> Yellow cards</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'yellowcards[1]', '-') }}</td>
        </tr>
        <tr>
          <td class="text-right">{{ getProperty(fixture.stats, 'substitutions[0]', '-') }}</td>
          <td class="text-center" width="150px">Substitutions</td>
          <td class="text-left">{{ getProperty(fixture.stats, 'substitutions[1]', '-') }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <section v-for="(type,i) in betType">
      <div class="col-sm-12 container-market">
        <div class="col-sm-12 gl-market-group-button">
          <span class="gl-market-group-button-text">{{ type.name }}</span>
          <span class="btn-add-show" @click="setCreateToggle(type.slug)"><i class="fa fa-plus text-info" v-show="!getCreateToggle(type.slug, 'editing')"></i> {{ getCreateToggle(type.slug, 'editing') ? 'ปิด' : 'เพิ่ม' }}</span>
        </div>

        <section class="group-key" v-for="(recordKey, i) in getOdds(type.slug,'odds')" @dblclick="setBreakSync(type.slug,true,false)">
          <div class="group-container" v-for="(records, ii) in recordKey">
            <div :class="includeClass(type.slug)">
              <div class="gl-participant gl-participant-general" v-for="(record, i) in setSortHDA(records)" :class="getChunk(type,record)">
                <span class="gl-participant-name"><span class="label label-danger label-xs" v-if="record.not_sync===1 && fixture.ref_status!='FT' "><i class="fa fa-refresh"></i></span> {{ record.header }}</span>
                <span class="gl-participant-handicap" v-show="isHandicap(record)">{{ record.handicap }}</span>
                <span class="gl-participant-total" v-show="isTotal(record)">{{ record.total }}</span>
                <span class="gl-participant-odds" v-show="!getBreakSync(type.slug)">{{ record.value }}</span>
                <span class="gl-participant-winning" v-show="record.winning>0 && !getBreakSync(type.slug)"></span>
                <span class="gl-participant-payment-rate" v-show="record.payment_rate>0 && !getBreakSync(type.slug)"><span class="label" :class="paymentClass(record)">{{ toFloat(record.payment_rate)}}</span></span>
                <span class="gl-participant-value-edit" v-show="getBreakSync(type.slug)"><input type="text" v-model="record.value"></span>
                <span class="gl-participant-active" v-show="getBreakSync(type.slug)"><label class="k-checks"><input type="checkbox" v-model="record.active"> Active</label></span>
                <span class="gl-participant-not-sync" v-show="getBreakSync(type.slug)"><label class="k-checks"><input type="checkbox" v-model="record.not_sync"> Not Sync</label></span>
                <span class="gl-participant-logs" v-html="getLastLogs(record)" v-show="!getBreakSync(type.slug)"></span>
              </div>
            </div>
          </div>
        </section>
        <div class="clearfix"></div>
        <div class="gl-market-group-action" v-show="getBreakSync(type.slug)">
          <div class="form-group">
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10">
              <label class="radio-inline k-checks">
                <input type="checkbox" @change.prevent="setSelectActiveAll(type.slug,$event)"> เปิดใช้งานทั้งหมด </label>
              <label class="radio-inline k-checks">
                <input type="checkbox" @change.prevent="setSelectNotSyncAll(type.slug,$event)"> ปิดการอัพเดตอัตโนมัติทั้งหมด </label>
            </div>
          </div>
          <button class="btn btn-sm btn-primary" @click="saveDataOdds(type.slug)">Save</button>
          <button class="btn btn-sm btn-danger" @click="setBreakSync(type.slug)">Cancel</button>
        </div>
        <div class="clearfix"></div>
        <section class="create-odds" v-show="getCreateToggle(type.slug)">
          <div class="create-odds-title"><span class="title-create-odd">สร้าง ราคาเพิ่มเติม</span></div>
          <div class="group-container" v-for="(records, i) in slugCreate[type.slug].odds">
            <div class="gl-participant gl-participant-general " v-for="(record, i) in records" :class="getChunk(type,record,false)">
              <span class="gl-participant-name">{{ record.showText }}</span>
              <span class="gl-participant-handicap-edit" v-show="record.type==='handicap'"><input type="number" v-model="record.handicap" placeholder="Handicap"></span>
              <span class="gl-participant-option" v-show="record.is_option">
                <select v-model="record.total" class="form-control">
                  <option value="">Select Label</option>
                  <option v-for="label in record.option">
                     {{ label }}
                  </option>
                </select>
                </span>
              <span class="gl-participant-total-edit" v-show="record.type==='total' && excludeType(type.slug) ">
                <input type="number" v-model="record.total" placeholder="Total" v-if="!record.totalText">
                <input type="text" v-model="record.total" placeholder="Total" v-if="record.totalText">
              </span>

              <span class="gl-participant-value-edit"><input type="number" v-model="record.value" placeholder="Rate"></span>
              <span class="gl-participant-active"><label class="k-checks"><input type="checkbox" v-model="record.active"> Active</label></span>
              <span class="gl-participant-not-sync"><label class="k-checks"><input type="checkbox" v-model="record.not_sync"> Not Sync</label></span>
              <span class="gl-participant-remove" v-show="record.remove" @click="removeOdds(type.slug,records, i)"><i class="fa fa-trash"></i> ลบ</span>
            </div>
          </div>
          <div class="gl-market-group-action">
            <button class="btn btn-sm btn-primary" @click="createDataOdds(type.slug)">Save</button>
            <button class="btn btn-sm btn-danger" @click="setCreateToggle(type.slug)">Cancel</button>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>
<script>
  import {
    getMoment,
    scoreDisplayScore,
    scoreDisplay,
    paymentClass,
    getLogs,
    setSortHDA,
    getMatchStatus,
    getTeamIcon
  } from './helpers'

  export default {
    name: 'sport-soccer',
    props: {
      fixtureId: {
        required: true,
      },
      switchUrl: {
        required: true,
      }
    },
    data() {
      return {
        showStats:false,
        slugCreateTemp: {},
        slugCreate: {
          'pre_match:full_time_result': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: '1',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw',
                  showText: 'Draw',
                  label: 'Draw',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: '2',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:double_chance': {
            'odds': [
              [
                {
                  header: 'Home/Draw',
                  showText: 'Home/Draw',
                  label: '1X',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw/Away',
                  showText: 'Draw/Away',
                  label: 'X2',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Home/Away',
                  showText: 'Home/Away',
                  label: '12',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:correct_score': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: '1-0',
                  active: 1,
                  not_sync: 0,
                  remove: 1,
                  type: 'total',
                  is_option: true,
                  option: [
                    '1-0', '2-0', '2-1', '3-0', '3-1', '3-2', '4-0', '4-1', '4-2', '4-3', '5-0', '5-1', '5-2', '5-3', '5-4', '6-0', '6-1', '6-2', '6-3', '6-4', '6-5', '7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '7-6'
                  ]
                },
                {
                  header: 'Draw',
                  showText: 'Draw',
                  label: 'Draw',
                  total: '0-0',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  remove: 1,
                  type: 'total',
                  is_option: true,
                  option: [
                    '0-0', '1-1', '2-2', '3-3', '4-4', '5-5', '6-6', '7-7'
                  ]
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  total: '1-0',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  remove: 1,
                  type: 'total',
                  is_option: true,
                  option: [
                    '1-0', '2-0', '2-1', '3-0', '3-1', '3-2', '4-0', '4-1', '4-2', '4-3', '5-0', '5-1', '5-2', '5-3', '5-4', '6-0', '6-1', '6-2', '6-3', '6-4', '6-5', '7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '7-6'
                  ]
                }
              ]
            ],
            editing: false
          },
          'pre_match:half_time_full_time': {
            'odds': [
              [
                {
                  header: 'Home-Home',
                  showText: 'Home-Home',
                  label: 'Home-Home',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Home-Draw',
                  showText: 'Home-Draw',
                  label: 'Home-Draw',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Home-Away',
                  showText: 'Home-Away',
                  label: 'Home-Away',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                }
              ],
              [
                {
                  header: 'Draw-Home',
                  showText: 'Draw-Home',
                  label: 'Draw-Home',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw-Draw',
                  showText: 'Draw-Draw',
                  label: 'Draw-Draw',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw-Away',
                  showText: 'Draw-Away',
                  label: 'Draw-Away',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                }
              ],
              [
                {
                  header: 'Away-Home',
                  showText: 'Away-Home',
                  label: 'Away-Home',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away-Draw',
                  showText: 'Away-Draw',
                  label: 'Away-Draw',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away-Away',
                  showText: 'Away-Away',
                  label: 'Away-Away',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:goals_over_under': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:both_teams_to_score': {
            'odds': [
              [
                {
                  header: 'Yes',
                  showText: 'Yes',
                  label: 'Yes',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: false,
                  is_option: false,
                  option: []
                },
                {
                  header: 'No',
                  showText: 'No',
                  label: 'No',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: false,
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
//          'pre_match:goalscorers': {},
//          'pre_match:multi_scorers': {},
          'pre_match:asian_handicap': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:goal_line': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:alternative_asian_handicap': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:alternative_goal_line': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:draw_no_bet': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: false,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: false,
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:result_both_teams_to_score': {
            'odds': [
              [
                {
                  header: 'Home-Yes',
                  showText: 'Home-Yes',
                  label: 'Home-Yes',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Home-No',
                  showText: 'Home-No',
                  label: 'Home-No',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
              ],
              [
                {
                  header: 'Away-Yes',
                  showText: 'Away-Yes',
                  label: 'Away-Yes',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away-No',
                  showText: 'Away-No',
                  label: 'Away-No',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
              ],
              [
                {
                  header: 'Draw-Yes',
                  showText: 'Draw-Yes',
                  label: 'Draw-Yes',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw-No',
                  showText: 'Draw-No',
                  label: 'Draw-No',
                  value: null,
                  active: 1,
                  not_sync: 0,
                  type: null,
                  is_option: false,
                  option: []
                },
              ]
            ],
            editing: false
          },
          'pre_match:handicap_result': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw',
                  showText: 'Draw',
                  label: 'Draw',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:alternative_handicap_result': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Draw',
                  showText: 'Draw',
                  label: 'Draw',
                  value: null,
                  total: null,
                  handicap: null,
                  active: 1,
                  not_sync: 0,
                  type: 'handicap',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:winning_margin': {
            'odds': [
              [
                {
                  header: 'Home',
                  showText: 'Home',
                  label: 'Home',
                  value: null,
                  total: null,
                  active: 1,
                  totalText: true,
                  remove: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Away',
                  showText: 'Away',
                  label: 'Away',
                  value: null,
                  total: null,
                  active: 1,
                  totalText: true,
                  remove: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Both',
                  showText: 'Both',
                  label: 'Both',
                  value: null,
                  total: null,
                  active: 1,
                  totalText: true,
                  remove: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
              ]
            ],
            editing: false
          },
          'pre_match:corners': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Exactly',
                  showText: 'Exactly',
                  label: 'Exactly',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:total_corners': {
            'odds': [
              [
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  remove: 1,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  remove: 1,
                  is_option: false,
                  option: []
                },
                {
                  header: 'Between',
                  showText: 'Between',
                  label: 'Between',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  remove: 1,
                  totalText: true,
                  is_option: false,
                  option: []
                },
              ]
            ],
            editing: false
          },
          'pre_match:alternative_corners': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Exactly',
                  showText: 'Exactly',
                  label: 'Exactly',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:corners_2_way': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:first_half_corners': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Exactly',
                  showText: 'Exactly',
                  label: 'Exactly',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:asian_total_corners': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          },
          'pre_match:1st_half_asian_corners': {
            'odds': [
              [
                {
                  header: 'Over',
                  showText: 'Over',
                  label: 'Over',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                },
                {
                  header: 'Under',
                  showText: 'Under',
                  label: 'Under',
                  value: null,
                  total: null,
                  active: 1,
                  not_sync: 0,
                  type: 'total',
                  is_option: false,
                  option: []
                }
              ]
            ],
            editing: false
          }
        },
        slug: {
          'pre_match:full_time_result': {},
          'pre_match:double_chance': {},
          'pre_match:correct_score': {},
          'pre_match:half_time_full_time': {},
          'pre_match:goals_over_under': {},
          'pre_match:both_teams_to_score': {},
          'pre_match:goalscorers': {},
          'pre_match:multi_scorers': {},
          'pre_match:asian_handicap': {},
          'pre_match:goal_line': {},
          'pre_match:alternative_asian_handicap': {},
          'pre_match:alternative_goal_line': {},
          'pre_match:draw_no_bet': {},
          'pre_match:result_both_teams_to_score': {},
          'pre_match:handicap_result': {},
          'pre_match:alternative_handicap_result': {},
          'pre_match:winning_margin': {},
          'pre_match:corners': {},
          'pre_match:total_corners': {},
          'pre_match:alternative_corners': {},
          'pre_match:corners_2_way': {},
          'pre_match:first_half_corners': {},
          'pre_match:asian_total_corners': {},
          'pre_match:1st_half_asian_corners': {}
        },
        fixtureRefId: null,
        fixture: {},
        type: 'pre_match',
        slugFlashData: {},
        betType: {},
        breakSync: {},
        timeSync: 30,
        baseTimeSync: 30,
      }
    },
    mounted() {
      this.getDataOdds()
      this.getDataInterVal()
    },
    methods: {
      getMoment(value, format = 'HH:mm', local = 'th') {
        return getMoment(value, format, local)
      },
      getDataInterVal() {
        setInterval(function () {
          this.timeSync--
          if (this.timeSync === 0) {
            this.getDataOdds()
            this.timeSync = _.cloneDeep(this.baseTimeSync)
          }
        }.bind(this), 1000)
      },
      reload(){
        this.getDataOdds()
        this.timeSync = _.cloneDeep(this.baseTimeSync)
      },
      getDataOdds() {
        const requestUrl = `spt/soccer/odds/pre_odds/${this.fixtureId}`
        axios.get(requestUrl)
          .then(response => {
            if (response.data) {
              this.betType = _.cloneDeep(response.data.betType)
              const preOdds = response.data.preOdds
              this.fixture = _.cloneDeep(response.data.fixture)
              this.fixtureRefId = this.fixture.ref_id
              for (let record of this.betType) {
                if (!_.get(preOdds, record.slug)) {
                  continue
                }
                Object.assign(preOdds[record.slug], {editing: false})
                if (!this.getBreakSync(record.slug)) {
                  this.slug[record.slug] = preOdds[record.slug]
                } else {
                  this.slugFlashData[record.slug] = preOdds[record.slug]
                }
              }
            }
          })
          .catch(err => {
//            console.dir(err)
            this.$message.error({
              showClose: true,
              message: 'ไม่สามารถโหลดข้อมูลได้',
              duration: 2000
            })
          })
      },
      syncFixtureById() {
        const requestUrl = `spt/soccer/${this.fixtureId}/sync`
        axios.post(requestUrl)
          .then(response => {
            this.timeSync = 5
            this.$message.success({
              showClose: true,
              message: 'อัพเดตข้อมูลการแข่งขันเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'ไม่สามารถโหลดข้อมูลได้',
              duration: 2000
            })

          })
      },
      saveDataOdds(slug) {
        const requestUrl = `spt/soccer/odds/update`
        const data = []
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              const oddChange = this.slug[slug].odds[odds][odds2][odd]
              data.push({
                id: oddChange.id,
                value: oddChange.value,
                active: oddChange.active ? 1 : 0,
                not_sync: oddChange.not_sync ? 1 : 0,
                spt_soccer_fixtures_id: this.fixtureId,
              })
            }
          }
        }

        axios.post(requestUrl, {odds: data})
          .then(response => {
            this.setBreakSync(slug, false)
            this.getDataOdds()
            this.$message.success({
              showClose: true,
              message: 'อัพเดตราคาเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด '+_.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })

      },
      createDataOdds(slug) {
        const requestUrl = `spt/soccer/odds/create`
        const data = []
        for (let odds  in _.get(this.slugCreate[slug], 'odds', [])) {
          for (let odd in _.get(this.slugCreate[slug], `odds.${odds}`)) {
            const oddChange = this.slugCreate[slug].odds[odds][odd]
            let dataSave = {
              header: oddChange.header,
              label: oddChange.label,
              value: oddChange.value,
              active: oddChange.active ? 1 : 0,
              not_sync: oddChange.not_sync ? 1 : 0,
              type: this.type,
              spt_soccer_fixtures_id: this.fixtureId,
              spt_soccer_fixtures_ref_id: this.fixtureRefId,
              slug: slug
            }
            if (oddChange.type === 'handicap') {
              dataSave.handicap = oddChange.handicap
            }
            if (oddChange.type === 'total') {
              dataSave.total = oddChange.total
            }
            data.push(dataSave)
          }
        }
//        swal({
//            title: "ยืนยันการเพิ่มราคา",
//            type: "warning",
//            showCancelButton: true,
//            confirmButtonColor: "#1ab394",
//            confirmButtonText: "ยืนยัน",
//            cancelButtonText: "ปิด",
//            closeOnConfirm: true
//          },
//          function () {
        axios.post(requestUrl, {odds: data, fixture_id: this.fixtureId})
          .then(response => {
            this.setCreateToggle(slug)
            this.getDataOdds()

            this.$message.success({
              showClose: true,
              message: 'เพิ่ม ราคาเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด '+_.get(err, 'response.data[0].message'),
              duration: 2000
            })
          })
//          }.bind(this))

      },
      getLastLogs(odds) {
        return getLogs(odds)
      },

      getBetTypeProps(slug, prop) {
        return _.get(_.find(this.betType, ['slug', slug]), prop)
      },
      getOdds(slug, prop, df = []) {
        return _.get(_.get(this.slug, slug), prop, df)
      },
      getProperty(data, key, df = '') {
        return _.get(data, key, df)
      },
      setSortHDA(odds) {
        return setSortHDA(odds)
      },
      setBreakSync(slug, force = true, toggle = true) {
        if (_.get(this.slug, `${slug}.editing`, false)) {
          if (!toggle) {
            return false
          }
          this.slug[slug].editing = false
          if (_.get(this.slugFlashData, slug) && force) {
            this.slug[slug] = _.cloneDeep(this.slugFlashData[slug])
          }
          return false
        } else {
          this.slugFlashData[slug] = _.cloneDeep(this.slug[slug])
          this.slug[slug].editing = true
          return true
        }
      },
      getBreakSync(slug) {
        return _.get(this.slug, `${slug}.editing`)
      },
      setSelectActiveAll(slug, e) {
        const status = e.target.checked
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              this.slug[slug]['odds'][odds][odds2][odd].active = status ? 1 : 0
            }
          }
        }
      },

      setSelectNotSyncAll(slug, e) {
        const status = e.target.checked
        for (let odds  in _.get(this.slug[slug], 'odds', [])) {
          for (let odds2 in _.get(this.slug[slug], ['odds', odds])) {
            for (let odd in _.get(this.slug[slug], ['odds', odds, odds2])) {
              this.slug[slug].odds[odds][odds2][odd].not_sync = status ? 1 : 0
            }
          }
        }
      },
      isHandicap(record) {
        if (record.handicap !== null) {
          return true
        }
        return false
      },
      isTotal(record) {
        if (record.total !== null) {
          return true
        }
        return false
      },
      setCreateToggle(slug, force = true) {
        if (_.get(this.slugCreate, `${slug}.editing`, false)) {
          this.slugCreate[slug].editing = false
          if (_.get(this.slugCreateTemp, slug) && force) {
            this.slugCreate[slug] = _.cloneDeep(this.slugCreateTemp[slug])
          }
          return false
        } else {
          this.slugCreateTemp[slug] = _.cloneDeep(this.slugCreate[slug])
          this.slugCreate[slug].editing = true
          return true
        }
      },
      getCreateToggle(slug) {
        return _.get(this.slugCreate, `${slug}.editing`)

      },
      addMoreOdds(slug) {
        const data = _.cloneDeep(_.last(this.slugCreate[slug].odds))
        this.slugCreate[slug].odds.push(data)
      },
      removeOdds(slug, records, key) {
//        console.dir(records)
//        if (_.get(records[key], 'remove_all', 0)) {
        records.splice(key, 1)
//        }
        const newData = []
        for (let odds  in _.get(this.slugCreate[slug], 'odds', [])) {
          if (_.get(this.slugCreate[slug], `odds.${odds}`).length) {
            newData.push(_.get(this.slugCreate[slug], `odds.${odds}`))
          }
        }
        this.slugCreate[slug].odds = _.cloneDeep(newData)
      },
      getChunk(type, record, show = true) {
        const slug = ['pre_match:total_corners', 'pre_match:correct_score']
        let className = ''
        if (!record.active) {
          className += 'c-unactive '
        }
        if (record.suspend === 1) {
          className += 'c-suspend '
        }

        if (_.includes(slug, type.slug) && show) {
          className += 'gl-cn-1'
        } else {
          if (type.chunk === 0) {
            className += 'gl-cn-3'
          } else {
            className += 'gl-cn-' + type.chunk
          }
        }
        return className
      },
      getInPlayScore(record) {
        return record.inplay_score ? record.inplay_score : '?-?'
      },
      getMatchStatus(fixture) {
        return getMatchStatus(fixture)
      },
      excludeType(type) {
        if (type === 'pre_match:correct_score') {
          return false
        }
        return true
      },
      includeClass(type) {
        const slug = ['pre_match:total_corners', 'pre_match:correct_score']
        if (_.includes(slug, type)) {
          return 'col-sm-4'
        }
        return ''
      },
      getTeamIcon(logoPath) {
        return getTeamIcon(logoPath)

      },
      paymentClass(record) {
        return paymentClass(record)
      },
      toFloat(value, fixed = 2) {
        return parseFloat(value).toFixed(fixed)
      },
      hideCreate(type) {
//        const slug = ['pre_match:winning_margin','pre_match:total_corners']
//        if (_.includes(slug, type)) {
//          return false
//        }
        return true
      },
      scoreDisplay(fixture) {
        return scoreDisplay(fixture)
      },
      scoreDisplayScore(fixture) {
        return scoreDisplayScore(fixture)
      }
    },
    created() {

    },
    computed: {},
    beforeMount() {
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/sports/soccerPreMatch.vue